module.exports = __webpack_public_path__ + "img/SetupAddProduct24.7fe10823.png";